const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20curated%20collection%20display%20with%20warm%20golden%20lighting%2C%20sophisticated%20editorial%20layout%2C%20premium%20aesthetic%2C%20soft%20shadows%2C%20clean%20minimal%20background%2C%20professional%20content%20showcase&width=800&height=560&seq=card-01&orientation=landscape',
    tag: '探花精选',
    title: '七月探花大神精选合集：不容错过的口碑佳作',
    desc: '本月探花一区与探花91社区联合推出精选合集，收录多位探花大神最新力作，内容涵盖多元题材。',
    meta: '12.8k 浏览 · 3天前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Artistic%20digital%20media%20collection%20with%20warm%20coral%20accents%2C%20editorial%20photography%2C%20refined%20layout%2C%20soft%20natural%20lighting%2C%20elegant%20composition%2C%20clean%20neutral%20background&width=800&height=560&seq=card-02&orientation=landscape',
    tag: '探花一区',
    title: '探花一区「夏日限定」专题：全新内容板块上线',
    desc: '探花一区全新策划的夏日限定专题正式上线，汇集本季最具人气的探花精品资源与独家内容。',
    meta: '9.6k 浏览 · 5天前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Premium%20content%20highlight%20showcase%20with%20soft%20warm%20tones%2C%20editorial%20style%2C%20luxurious%20aesthetic%2C%20clean%20background%2C%20sophisticated%20card%20layout%2C%20professional%20photography&width=800&height=560&seq=card-03&orientation=landscape',
    tag: '探花大神',
    title: '九一探花传奇大神回归：经典系列再续新篇章',
    desc: '久违的九一探花知名创作者携全新系列作品回归，延续一贯的高品质创作风格，引发社区广泛关注。',
    meta: '8.3k 浏览 · 1周前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20resource%20curation%20display%20with%20amber%20and%20gold%20tones%2C%20editorial%20design%2C%20clean%20minimal%20layout%2C%20soft%20lighting%2C%20professional%20content%20showcase%2C%20refined%20aesthetic&width=800&height=560&seq=card-04&orientation=landscape',
    tag: '探花91',
    title: '探花91社区月度热门TOP20揭晓，神作盘点',
    desc: '探花91社区月度热门榜单新鲜出炉，评选出本月口碑与人气双高的20部探花精品内容。',
    meta: '7.1k 浏览 · 2周前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Artistic%20curated%20showcase%20with%20warm%20lighting%2C%20sophisticated%20editorial%20style%2C%20clean%20composition%2C%20premium%20digital%20display%2C%20soft%20shadows%2C%20elegant%20neutral%20background&width=800&height=560&seq=card-05&orientation=landscape',
    tag: '极品探花',
    title: '极品探花高分合集推荐：品味与品质的双重保障',
    desc: '精选探花探花平台近期高分评价内容，覆盖探花大神作品、探花一区热门及探花91口碑推荐。',
    meta: '6.5k 浏览 · 3周前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20content%20platform%20with%20warm%20golden%20highlights%2C%20editorial%20photography%2C%20refined%20layout%2C%20clean%20background%2C%20sophisticated%20aesthetic%2C%20professional%20composition&width=800&height=560&seq=card-06&orientation=landscape',
    tag: '探花新品',
    title: '探花新品速递：本周最新上架资源一览',
    desc: '本周探花系列平台迎来多部新上架内容，覆盖探花大神合集、探花精选及探花一区多元板块。',
    meta: '5.2k 浏览 · 昨天',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20resource%20collection%20with%20warm%20coral%20and%20amber%20tones%2C%20editorial%20design%2C%20sophisticated%20layout%2C%20clean%20minimal%20background%2C%20professional%20showcase%2C%20soft%20natural%20lighting&width=800&height=560&seq=card-07&orientation=landscape',
    tag: '探花合集',
    title: '探花大神完整作品合集：一站式系列内容导航',
    desc: '为探花迷整理多位探花大神的完整作品合集，包含系列全作与相关推荐，方便按创作者浏览。',
    meta: '4.8k 浏览 · 4天前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-image-line"></i>
            图文精选
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            精选图文
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            探花系列平台编辑团队精心挑选的高质量内容推荐
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card, i) => (
            <article
              key={i}
              className={`group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-300 cursor-pointer ${
                i === 0 ? 'sm:col-span-2 sm:row-span-1' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-[4/3]'}`}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i > 3 ? 'lazy' : undefined}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-primary-700">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {card.desc}
                </p>
                <div className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{card.meta}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}